module.exports = __webpack_public_path__ + "img/i-sta-2.3df1b6a3.png";